import { placeholderStrategy } from './placeholder_strategy';

// CE has no real groupings yet, so this is just the placeholder (see placeholder_strategy.js).
export const strategies = [placeholderStrategy];
